import type { LanguageModelV1Source } from '@ai-sdk/provider';
import { memo } from 'react';
import { Link } from '~/components/ui/Link';

interface SearchSourceProps {
  index: number;
  source: LanguageModelV1Source;
}

export const SearchSource = memo<SearchSourceProps>(({ index, source }) => (
  <Link
    className="text-xs bg-bolt-elements-background-depth-3 dark:bg-bolt-elements-background-depth-4 text-bolt-elements-textSecondary hover:text-bolt-elements-textPrimary transition-theme py-0.5 px-2 rounded-md max-w-[200px] truncate"
    href={source.url}
    target="_blank"
  >
    {source.title || index}
  </Link>
));

SearchSource.displayName = 'SearchSource';
